const paragraph = (editor) => {

    editor.BlockManager.add(`paragraph`, {
        category: 'Typography',
        label: `Paragraph`,
        attributes: { class: 'fa fa-paragraph' },
        content: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>`
    });
} 

export default paragraph;